import { httpClient } from "@/services";
import requestKeys from "@/constants/requestKeys";
import { managerStatementsHeaders, managerStatementsHeadersUser } from "@/pages/Accounting/ManagerStatements/managerStatementsHeaders";

export default {
	state: {
		managerStatementsItem: null,
		managerStatementsList: null,
		managerStatementsFilters: null,
		managerStatementsTotals: null,
		managerStatementsLimit: null,
		managerStatementsOrder: null,
		managerStatementsSort: null,
		managerStatementsTotal: null,
		managerStatementsMonth: [],
		managerStatementsDepartments: [],
	},
	mutations: {
		updateManagerStatementsList(state, { rows, limit, order, sort, total, month, departments }) {
			state.managerStatementsList = rows;
			state.managerStatementsLimit = limit;
			state.managerStatementsOrder = order;
			state.managerStatementsSort = sort;
			state.managerStatementsTotal = total;
			state.managerStatementsMonth = month.reverse();
			state.managerStatementsDepartments = departments;
			state.managerStatementsTotals = { month: total };
		},
		updateManagerStatementsFilters(state, { filter }) {
			state.managerStatementsFilters = filter;
		},
		updateManagerStatements(state, { rows }) {
			state.managerStatementsItem = rows;
		}
	},
	actions: {
		async getManagerStatements({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/salary-statements/list', values);
				commit('updateManagerStatementsList', data);
				commit('updateSettings', { settings: data.settings, key: requestKeys.MANAGER_STATEMENTS, defaultHeader: managerStatementsHeaders });
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getManagerStatementsUser({ commit, dispatch }, values) {
			dispatch("actionPreloader", true);
			try {
				const { data } = await httpClient.post('/salary-statements/list', values);
				commit('updateManagerStatementsList', data);
				commit('updateSettings', { settings: data.settings, key: requestKeys.MANAGER_STATEMENTS, defaultHeader: managerStatementsHeadersUser });
			} catch (e) {
				console.error(e);
			} finally {
				dispatch("actionPreloader", false);
			}
		},

		async getManagerStatementsFilters({ commit }, values) {
			try {
				const { data } = await httpClient.post('/salary-statements/filters', values);
				if (data) commit('updateManagerStatementsFilters', data);
			} catch (e) {
				console.error(e);
			}
		},

		async getManagerStatementsCreate({ commit }, values) {
			try {
				const { data } = await httpClient.post('/salary-statements/create', values);
				if (data && data.status) {
					commit('updateManagerStatements', data);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async onManagerStatements({ dispatch }, rows) {
			try {
				const { data } = await httpClient.post('/salary-statements', { rows });
				if (data) {
					return data;
				} 
				dispatch("setAlert", { type: "error", message: "Something went wrong!" });
				
			} catch (e) {
				console.error(e);
			}
		},

		async onDispatcherStatements({ dispatch }, values) {
			try {
				const { data } = await httpClient.post('/dispatcher/statement', values);
				if (data) {
					return data;
				}
				dispatch("setAlert", { type: "error", message: "Something went wrong!" });

			} catch (e) {
				console.error(e);
			}
		},

		async onManagerStatementsView({ commit }, id) {
			try {
				const { data } = await httpClient.get(`/salary-statements/${ id }/edit`);
				if (data && data.status) {
					commit('updateManagerStatements', data);
				}
			} catch (e) {
				console.error(e);
			}
		},

		async onManagerStatementsRemoveItem({ dispatch }, item) {
			const { id, total, dispatcher, department, month } = item;
			try {
				const { data } = await httpClient.delete(`/salary-statements/${ id }`);
				if (data) {
					dispatch("setAlert", {
						type: "success",
						message: `🗑️ Removed manager statement 🧾 of <b>${ total }</b> 💰 for <b>${ dispatcher }</b> 👤 from <b>${ department }</b> 🏢 (${ month } 📅).`
					});
					return data;
				}

			} catch (e) {
				console.error(e);
			}
		},

		onClearManagerStatements({ commit }) {
			commit('updateManagerStatements', { rows: null });
		}
	},
	getters: {
		managerStatementsItem: (s) => s.managerStatementsItem,
		managerStatementsList: (s) => s.managerStatementsList,
		managerStatementsFilters: (s) => s.managerStatementsFilters,
		managerStatementsTotals: (s) => s.managerStatementsTotals,
		managerStatementsLimit: (s) => s.managerStatementsLimit,
		managerStatementsOrder: (s) => s.managerStatementsOrder,
		managerStatementsSort: (s) => s.managerStatementsSort,
		managerStatementsTotal: (s) => s.managerStatementsTotal,
		managerStatementsMonth: (s) => s.managerStatementsMonth,
		managerStatementsDepartments: (s) => s.managerStatementsDepartments,
	}
};
